import { render, staticRenderFns } from "./ui-radio.vue?vue&type=template&id=71c1af6d&lang=pug&"
import script from "./ui-radio.vue?vue&type=script&lang=js&"
export * from "./ui-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c1af6d')) {
      api.createRecord('71c1af6d', component.options)
    } else {
      api.reload('71c1af6d', component.options)
    }
    module.hot.accept("./ui-radio.vue?vue&type=template&id=71c1af6d&lang=pug&", function () {
      api.rerender('71c1af6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-radio.vue"
export default component.exports